module.exports = __webpack_public_path__ + "img/4-min.9d22fed7.jpg";